import { MapID, POI_ID } from '../navigator/navigator.model';

export const AutosaveKey = 'autosave';
export type AutosaveValue = {
  poi: POI_ID;
  mapId?: MapID;
  items?: Record<string, number>;
};
